import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Spin } from "@devowl-wp/react-folder-tree";
import { resolveIcon } from "../../utils/icons.js";
function FolderBoxHeader({ icon, folder }) {
    return /*#__PURE__*/ _jsxs("span", {
        children: [
            icon,
            " ",
            resolveIcon(folder.icon),
            " ",
            folder.title
        ]
    });
}
/**
 * A component showing a container for a folder option. For example the metabox
 * or manual placement for nodes (rearrange).
 */ function FolderBox({ busy, icon, folder, errors = [], header = true, children }) {
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: busy === undefined ? false : busy,
        size: "small",
        children: /*#__PURE__*/ _jsxs("div", {
            className: classNames("rml-postbox", {
                "rml-postbox--no-header": !header
            }),
            children: [
                header && /*#__PURE__*/ _jsx("h2", {
                    children: /*#__PURE__*/ _jsx(FolderBoxHeader, {
                        icon: icon,
                        folder: folder
                    })
                }),
                errors.length > 0 && /*#__PURE__*/ _jsx("ul", {
                    style: {
                        marginTop: 0
                    },
                    children: errors.map((e, i)=>/*#__PURE__*/ _jsx("li", {
                            children: e
                        }, i))
                }),
                children && /*#__PURE__*/ _jsx("div", {
                    className: "inside",
                    children: children
                }),
                folder.id > 0 && /*#__PURE__*/ _jsxs("span", {
                    style: {
                        float: "right",
                        paddingBottom: "5px",
                        fontSize: "10px",
                        opacity: 0.5
                    },
                    children: [
                        "ID #",
                        folder.id
                    ]
                })
            ]
        })
    });
}
export { FolderBox, FolderBoxHeader };
